<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                v-model="searchForm.nursinghomeId"
                style="width: 100%"
                placeholder="服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="购买人" prop="nursinghomeId">
              <el-input
                clearable
                v-model="searchForm.deviceName"
                placeholder="设备名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备状态" prop="deviceTypeId">
              <el-select v-model="searchForm.deviceTypeId" style="width: 100%" placeholder="设备类型">
                <el-option
                  v-for="item in deviceStatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
  
          <el-col :span="6">
            <el-form-item label="金额区间" prop="name">
             
            </el-form-item>
          </el-col>
          
        
  
          <el-col :span="12">
            <el-form-item label="购买日期" prop="onlineStatus">
            
            </el-form-item>
          </el-col>
  
          <el-col :span="6">
            <div style="float: right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
  
        <template slot="menuLeft">
          <el-button
            v-if="permissionList.addBtn"
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addNursingForm"
          >
            新 增</el-button
          >
        </template>
        
      </avue-crud>
  
      
      
    </basic-container>
  </template>
  <script>
 


  import { getDictionary } from '@/api/common.js';
  import searchFromShow from '@/components/search-form-show/index';
  import { mapGetters } from 'vuex';
  import {
    getNursinghome,
    getWristbandPage,
    getDeviceTypeList,
    wristbandRemove,
    deviceStart,
    deviceStop,
  } from '../api/serveItemManage';
  export default {
    components: { searchFromShow, },
    data() {
      return {
     
        searchForm: {
          nursinghomeId: '',
          warehouseId: '',
          type: '0',
          consumableCode: '',
          consumableName: '',
          specification: '',
          upWarnFlag: 'false',
          downWarnFlag: 'false',
        },
  
        projectList: [],
  
        provideList: [
          {
            dickey: '0',
            dicvalue: '购买',
          },
          {
            dickey: '1',
            dicvalue: '免费',
          },
        ],
        option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '设备名称',
              prop: 'deviceName',
            },
           
            {
              label: '设备型号',
              prop: 'deviceName',
            },
            {
              label: '设备编号',
              prop: 'deviceName',
            },
            {
              label: '设备类别',
              prop: 'deviceName',
            },
            {
              label: '所属设备大类',
              prop: 'deviceName',
            },
            {
              label: '购买人',
              prop: 'deviceName',
            },
            {
              label: '购买时间',
              prop: 'deviceName',
            },
            {
              label: '购买金额',
              prop: 'deviceName',
            },
            {
              label: '付款渠道',
              prop: 'deviceName',
            },
            {
              label: '配送地址',
              prop: 'deviceName',
            },
            {
              label: '配配送时间送地址',
              prop: 'deviceName',
            },
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
     
        nursinghomeIdList: [],
      
      };
    },
    created() {
      this.initData();
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
  
          delBtn: this.vaildData(this.permission.deviceManage_del, false),
        };
      },
    },
    mounted() {
      this.calcHeight();
    },
    activated() {
      // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
      this.$nextTick(() => {
        this.$refs.crud.refreshTable();
      });
    },
    methods: {
  
   
    
   
  
    
  
     
      nursinghomeIdChange(nursinghomeId) {
        
      },
      searchRecord() {
        this.page.currentPage = 1;
        if (this.searchForm.upWarnFlag == '') {
          this.searchForm.upWarnFlag = false;
        }
        if (this.searchForm.downWarnFlag == '') {
          this.searchForm.downWarnFlag = false;
        }
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'nursinghomeId');
        this.searchForm.type = '0';
      },
  
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      initData() {
        getNursinghome().then((res) => {
          this.nursinghomeIdList = res.data;
          if (this.nursinghomeIdList.length > 0) {
            this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
            this.onLoad();
          }
        });
       
      },
  
      onLoad() {
        if (this.searchForm.nursinghomeId != '') {
          this.loading = true;
  
          getWristbandPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #alarmRule > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  